<template>
  <div>
    <checklist-input
      :editable="editable"
      :name="`checklist-item-${model.id}-subitem-${subitem.id}`"
      :label="description"
      :model-value="subitemValue"
      @update:modelValue="handleModelSubitemChanged"
    ></checklist-input>
  </div>
</template>

<script>
  import ChecklistInput from './ChecklistInput.vue'

  export default {
    components: { ChecklistInput },
    props: {
      editable: {
        type: Boolean,
        required: false,
        default: true,
      },
      model: {
        type: Object,
        required: true,
      },
      subitem: {
        type: Object,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      subitemValue: {
        type: String,
        required: false,
        default: '',
      },
    },
    emits: ['update:subitemValue'],
    data() {
      return {
        //
      }
    },
    methods: {
      handleModelSubitemChanged($event) {
        this.$emit('update:subitemValue', $event)
      },
    },
  }
</script>
